import React from 'react'
import SponsorBadge from 'components/ad_types/SponsorBadge'
import './HeaderTitle.scss'

const HeaderTitle = ({ title, isHeader, allowDarkMode, showSponsorbadge = true }) => {
    return (
        <div className={`header_title__cont ${allowDarkMode ? 'darkMode' : ''}`}>
            {!isHeader && <h3 className="header_title">{title}</h3>}
            {showSponsorbadge && (
                <div className="sponsor__cont">
                    <SponsorBadge targetMode="adUnit" />
                </div>
            )}
        </div>
    )
}

export default HeaderTitle
